import { useQueryClient } from '@tanstack/react-query';
import useApiMutation from '_api/mutations/useApiMutation';
import { GET_ALL_ADMIN_THERAPIST_KEY } from '_api/queries/therapist';

export const DELETE_THERAPIST_KEY = 'delete-therapist';

export const useDeleteTherapist = () => {
  const queryClient = useQueryClient();
  return useApiMutation<{}, { therapistId: number }>(
    ({ therapistId }) => `/therapist/${therapistId}`,
    'delete',
    {},
    {
      mutationKey: [DELETE_THERAPIST_KEY],
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: [GET_ALL_ADMIN_THERAPIST_KEY] });
      },
    },
  );
};
